<template>
    <div class="app-inner">
      <div class="public-btn-small flex align-cen posta">
            <div class="public-btn-small-plan"  @click="reback" style="margin-left:0">
                返回
            </div>
           <el-button type="primary" :loading="loading" class="public-btn-small-primary public-btn-small-load" style="margin-left:16px"
           @click="onSubmit('ruleForm')"
            >
                {{$route.query.id ? '修改' : '保存'}}
           </el-button>
            </div>
             <div class="edit-from">
                       <div class="public-tit flex align-cen">
            <div class="public-tit-list">
                <i class="icon-al-picture-fill"></i>  轮播图信息
            </div>
        </div>
        <el-form ref="ruleForm" :model="form" label-width="130px" :rules="rules" class="flex align-cen">
              <el-form-item label="轮播图名称：" prop="name">
                    <el-input v-model="form.name" placeholder="请输入轮播图名称【1-20】" clearable></el-input>
                </el-form-item>
                <div class="flex align-cen">
                   <el-form-item label="发布渠道：" prop="channelFirst">
                 <el-select v-model="form.channelFirst" placeholder="请选择【一级】"
                 @change="pushOpt"
                clearable
                >
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.label"
                      >
                    </el-option>
                  </el-select>
                 </el-form-item>
                  <el-form-item  prop="channelSecond" class="nolbal">
                 <el-select v-model="form.channelSecond" placeholder="请选择【二级】"
                clearable
                >
                    <el-option
                      v-for="item in options1"
                      :key="item.value"
                      :label="item.label"
                      :value="item.label"
                      >
                    </el-option>
                  </el-select>
                 </el-form-item>
                     </div>
 
                 <el-form-item label="轮播图详情：" prop="particularType">
                <el-radio v-model="form.particularType" label="1"  @change="restCh">上传HTML链接</el-radio>
                <el-radio v-model="form.particularType" label="2" @change="restCh">编辑器录入</el-radio>
              </el-form-item>
              <el-form-item label="HTML链接："  prop="link" class="Flex-w" v-if="form.particularType == 1">
                    <el-input v-model="form.link" placeholder="注意：链接需加前缀http://或https://，否则会跳转错误" clearable></el-input>
                </el-form-item>
               <el-form-item label="正文内容：" prop="message" class="el-ipt-quill " v-if="form.particularType == 2">
                    <quillTemplate  @sendStatus="emitFun" :propData="form.message"
                    ref="quillTemplate"
                    :noneboo="$route.query.type== 2 ? false : true"
                    ></quillTemplate>
                 </el-form-item>
                     <!-- <el-form-item label="轮播图片：" :prop="selectType == 1 ? 'pic' : ''" v-if="selectType == 1 ">
                    <el-upload
                    class="avatar-uploader"
                    :action="$config.baseUrl + '/admin/sys-file/upload'"
                    :headers="headers"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess"
                    :disabled="uploadBoolean"
                    >
                    <div slot="tip" class="el-upload__tip" >建议尺寸：<span style="color:#f56c6c">1920*1080</span></div>
                    <img :src="form.pic" class="avatar" v-if="form.pic">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    <span v-if="form.pic" class="el-upload-list__item-actions">
                        <span class="upload-icon">
                            <span class="el-uploads-span" style="margin-right: 10px;" @click.stop="oploadImgPre">
                                <i class="el-icon-zoom-in"></i>
                            </span>
                            <span class="el-upload-span" @click.stop="oploadImgDel">
                                <i class="el-icon-delete"></i>
                            </span>
                        </span>
                    </span>
                    <el-dialog :visible.sync="oploadDialogVisible" size="tiny" :append-to-body="true" :show-close="false">
                        <img width="100%" :src="form.pic" alt="">
                    </el-dialog>
                    </el-upload>
                 </el-form-item> -->
                  <el-form-item label="轮播图片/视频：" prop="videoUrl"  class="el-form-item Flex-w">
                       <div class="videodiv">
                   <el-upload   drag 
                   :action="$config.baseUrl + '/admin/sys-file/upload'" accept="video/*,image/*" 
                      :headers="headers" :before-upload="onBeforeUploadVideo" 
                      :on-success="onSuccessVideo" :on-error="onErrorVideo" 
                      :on-progress="uploadVideoProcess"
                      :show-file-list="false"
                    :multiple="false">
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                   <div class="el-upload__tip" slot="tip" v-if="!form.videoUrl">请上传图片或视频，官网建议尺寸：<span style="color:#f56c6c">1920*460</span>，小程序建议尺寸：<span style="color:#f56c6c">430*240</span></div>
                    </el-upload>
                    <div  class="el-upload__tip" v-if="form.videoUrl">轮播图片/视频地址：<span style="color:#f56c6c">{{form.videoUrl}}</span></div>
                        </div>
                  </el-form-item>
                  <el-form-item label="轮播图描述："  class="Flex-w">
                    <el-input
                        type="textarea"
                        :rows="4"
                        placeholder="请输入描述"
                        maxlength="100"
                        v-model="form.description">
                        </el-input>

                  </el-form-item>
        </el-form>
             </div>
    </div>
</template>
<script>
import quillTemplate from "@/components/quill/index.vue"; //富文本组件
import  Format from "../../../../utils/auth.js"  
import LocaStorage from "../../../../utils/localstorage.js" //本地存储公共方法
import { deleteBanner,editBanner} from "@/api/index/index"  //轮播图详情
export default {
    name:'addBanner',
    components: {
    quillTemplate,
    },
    data() {
        return {
             progressFlag:false,
             loadProgress: 0, // 动态显示进度条
            oploadDialogVisible:false,
            headers:{},
            uploadBoolean:false,
            selectType:'1',
            options:[
              {
               value: '1',
               label: '和隆优化官网'
              },
              {
               value: '2',
               label: '和隆软件官网'
              },
               {
               value: '3',
               label: '微信小程序'
              }
              ],
              options1:[
              ],
            loading:false,
            form:{
                name:'',
                channelFirst:'',
                channelSecond:'',
                particularType:'',
                link:'',
                message:'',
                pic:'',
                videoUrl:'',
                description:''
            },
            fileList:[],
             rules:{
                  name: [
                     {
                        trigger: "blur",
                        message:'请输入轮播图名称',
                        required: true, 
                     },
                      { min: 1, max: 20, message: '超出长度', trigger: 'blur' }
                 ],
                 channelFirst: [{ required: true, message: '请选择发布渠道一级', trigger: 'change' }],
                 channelSecond: [{ required: true, message: '请选择发布渠道二级', trigger: 'change' }],
                 particularType: [{ required: true, message: '请选择轮播图详情', trigger: 'blur' }],
                 link: [{ required: true, message: '请输入HTML链接', trigger: 'blur' }],
                 message: [{ required: true, message: '请输入编辑详情', trigger: 'blur' }],
                 pic: [{ required: true, message: '请上传轮播图片', trigger: 'change' }],
                 videoUrl: [{ required: true, message: '请上传轮播图片', trigger: 'change' }],
             }
        }
    },
    created() {
           let token = LocaStorage.setAge().get('token')
        if(token){
            this.headers = {
                'Authorization': token
            }
        }
        this.getDetail()
    },
    methods: {
      // 发布渠道一二级联动
      pushOpt(e){
       if(e == '和隆优化官网' || e == '和隆软件官网'){
        this.options1 = [
               {
               value: '1',
               label: '官网首页'
              },
              {
               value: '2',
               label: '课程首页-网页端'
              }
        ]
       }else if(e == '微信小程序'){
        this.options1 = [ 
          {
             value: '1',
               label: '获客小程序首页'
          }
        ]
       }else{
        this.options1 = []
       }
      },
        // 保存
        onSubmit(formName){
            let params = {
                name:this.form.name,
                channelFirst:this.form.channelFirst,
                channelSecond:this.form.channelSecond,
                particularType:this.form.particularType,
                particulars:this.form.particularType=='1' ? this.form.link : this.form.message,
                picUrl:this.form.videoUrl,
                description:this.form.description
            }
            let method = "post"
             if(!this.$route.query.id) params = {...params},method = "post";
             if(this.$route.query.id) params = {...params,id:this.$route.query.id},method = "put";
             this.$refs[formName].validate((valid) => { 
                if(valid){
                     this.commentBness(params,method)
                }
              })
        },
             commentBness(params,method){
               this.loading = true
                editBanner(params,method)
                        .then(res => {
                           if(res.code == 0){
                            this.loading = false
                            if(!this.$route.query.id)  this.$util.Notifi('新增成功','success','fa-check'); 
                           if(this.$route.query.id) this.$util.Notifi('修改成功','success','fa-check');
                          
                                setTimeout(() => {
                           this.$router.push("/HomeWebsite")
                             }, 100);
                           }else{
                             this.loading = false
                            this.$util.Notifi(res.msg,'error','fa-exclamation-circle');
                           }
                        })
                        .catch(err => {
                           this.loading = false
                        })
        },
        // 获取详情
        getDetail(){
            deleteBanner(
                {id:this.$route.query.id},
                'get')
             .then(res => {
                this.form = {
                    name:res.data.name,
                    channelFirst:res.data.channelFirst,
                    channelSecond:res.data.channelSecond,
                    particularType:res.data.particularType,
                    link:res.data.particularType=='1' ? res.data.particulars : '',
                    message:res.data.particularType=='2' ? res.data.particulars : '',
                    videoUrl:res.data.picUrl,
                    description:res.data.description   
                }
             })
             .catch(err => {})
        },
        oploadImgDel(){
              this.form.pic = ''
                let _this= this
                setTimeout(function(){
                    _this.uploadBoolean = false
                },1000)
            },
         oploadImgPre(){
          this.oploadDialogVisible = true
            },
     handleAvatarSuccess(res, file) {
        this.form.pic = res.data.url
        if(this.form.pic){
        this.uploadBoolean = true
         }
      },
        emitFun(val){
            this.form.message = val
        },
        // 轮播图详情改变时
        restCh(){
            this.$refs.ruleForm.clearValidate()
        },
        // 返回
        reback(){
             this.$router.push("/HomeWebsite")
        },
        // 发布渠道
        classSelect1(value){
             if(value){
                let index = value.length-1
                this.form.classifyId = value[index]
                // this.$refs.cascaderRef.dropDownVisible = false
            }else{
               this.form.classifyId = "" 
               this.$refs.cascaderRef.dropDownVisible = false
            }
         },
             // 视频上传成功钩子
        onSuccessVideo (res) {
      if (res.code == 0) {
        this.form.videoUrl = res.data.url
        this.$util.Notifi('上传成功','success','fa-check')
      } else {
        this.$message.error(res.msg)
      }
    },
       // 文件上传失败时的钩子
    onErrorVideo () {
      this.$message.error('上传失败')
    },
            // el-文件上传组件
    onBeforeUploadVideo (file) {
      let acceptArr = [
          "video/mp4",
          "video/ogg",
          "video/flv",
          "video/avi",
          "video/wmv",
          "video/rmvb",
          "image/jpg",
          "image/jpeg",
          "image/png"
        ]
      const isVideo = acceptArr.includes(file.type)
      
      const isLt1M = file.size / 1024 / 1024 < 150
      if (!isVideo) {
        this.$message.error("请上传正确的格式")
      }
      if (!isLt1M) {
        setTimeout( () => {this.$message.error('上传文件大小不能超过 150MB!')}, 10) 
        
      }
      return isLt1M && isVideo
    },
       // 视频上传进度
      uploadVideoProcess(event, file, fileList) {
          this.progressFlag = true; // 显示进度条
          this.loadProgress = parseInt(event.percent); // 动态获取文件上传进度
          if (this.loadProgress >= 100) {
              this.loadProgress = 100
              setTimeout( () => {this.progressFlag = false}, 1000) // 一秒后关闭进度条
          }
      },
    },
}
</script>
<style lang="scss" scoped>
  .edit-from{
        margin-bottom: 44px;
            .el-form{
            flex-wrap: wrap;
            margin-top: 20px;
         .el-form-item{
            width: 50%;
        .el-input,.el-cascader{
            width: 80%;
        }
       .el-input-group{
            width: 80%;
        }
         .el-select{
            width: 170px;
         }
        .el-textarea{
            width: 50%;
        }
        }
               .el-ipt-quill{
            width: 100% !important;
        }
         }
        .App-tab{
            margin: 20px 0;
            
        }
    }
::v-deep{
    .nolbal{
        .el-form-item__content{
            margin-left: 50px !important;
        }
    }
    .videodiv{
        .el-upload-dragger{
            width: 100%;
        }
    }
     .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
   width: calc(100% - 120px);
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar {
    width: 100%;
    height: 180px;
    display: block;
  }
  .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
         width:100%;
        height: 180px;
        line-height: 180px;
        text-align: center;
    }
   .upload-icon {
        position: absolute;
        top: 50%;
        margin-left: -28px;
        margin-top: -18px;
    }
    .el-dialog{
        width: 30%;
    }
    .el-list-enter-active,.el-list-leave-active{
        transition: none;
    }
    .el-list-enter,.el-list-leave-active {
      opacity: 0;
    }
    .el-upload-list {
      height: 40px;
    }
    }
</style>